import { useEffect, useState } from 'react';
import { fetchDashboardCardData } from '../../../services/dashboard';
import PageLoader, { PageSmallLoader } from '../../../component/PageLoader';
import expiryIcon from '../../../assets/image/expiry_icon.svg';
import stockIcon from '../../../assets/image/check_stock_icon.svg';
import warningIcon from '../../../assets/image/warning_icon.svg';
import { getDate } from '../../../utils/dateUtils';
import { addDays } from 'date-fns';
import { useNavigate } from 'react-router-dom';

const InventorySummary = ({ card, isCustomizing, handleRemoveCard, filter }) => {
	const { title, layout_card_id } = card;
	const [data, setData] = useState();
	const [isLoading, setLoading] = useState(false);
	const suburl = localStorage.getItem('suburl');
	const navigate = useNavigate();

	const handleFetchInventorySummaryData = async () => {
		try {
			setLoading(true);
			const res = await fetchDashboardCardData(layout_card_id, {
				filter_by: filter.filter_by,
				start_date:
					filter.start_date !== null ? addDays(new Date(filter.start_date), 1).toISOString() : '',
				end_date:
					filter.end_date !== null ? addDays(new Date(filter.end_date), 1).toISOString() : '',
			});
			setData(res[layout_card_id]);
		} catch (error) {
		} finally {
			setLoading(false);
		}
	};

	useEffect(() => {
		handleFetchInventorySummaryData();
	}, []);

	return (
		<div className="text-start">
			<div className="px-3 py-3 grids-header-bg-color rounded-top-4">
				<h3 className="fs-4 font-semibold text-dark">{title}</h3>
			</div>
			{isLoading ? (
				<div
					className="d-flex justify-content-center align-items-center"
					style={{ minHeight: '140px' }}
				>
					<PageSmallLoader />
				</div>
			) : (
				<div className=" px-3 d-flex justify-content-between text-start py-2">
					{isCustomizing && (
						<div
							style={{
								position: 'absolute',
								top: -13,
								right: -13,
								display: 'flex',
								justifyContent: 'center',
								alignItems: 'center',
								width: '20px',
								height: '20px',
								backgroundColor: 'red',
								borderRadius: '50%',
								cursor: 'pointer',
								zIndex: 100,
							}}
							onTouchStart={(e) => {
								e.preventDefault();
								e.stopPropagation();
								handleRemoveCard(layout_card_id, e);
							}}
							onClick={(e) => {
								e.preventDefault();
								e.stopPropagation();
								handleRemoveCard(layout_card_id, e);
							}}
						>
							<div
								style={{
									color: '#000',
									fontSize: '16px',
									fontWeight: '600',
									lineHeight: '1',
									paddingBottom: '5px',
								}}
							>
								−
							</div>
						</div>
					)}

					<div>
						<div
							className="d-flex align-items-center py-2 cursor-pointer"
							onClick={() => {
								navigate(`/user/${suburl}/product?near_expiry_stocks=true`);
							}}
						>
							<div
								className="p-1 rounded-2"
								style={{
									backgroundColor: 'rgba(255, 0, 0, 0.10)',
								}}
							>
								<img
									src={expiryIcon}
									alt="expiry"
									width={20}
									height={20}
								/>
							</div>
							<span className="fs-5 px-3 text-semibold text-start text-dark">Expiring Soon</span>
						</div>
						<div
							className="d-flex align-items-center py-2 cursor-pointer"
							onClick={() => {
								navigate(`/user/${suburl}/product?low_stock_products=true`);
							}}
						>
							<div
								className="p-1 rounded-2"
								style={{
									backgroundColor: 'rgba(254, 197, 61, 0.10)',
								}}
							>
								<img
									src={warningIcon}
									alt="warning"
									width={20}
									height={20}
								/>
							</div>
							<span className="fs-5 px-3 text-semibold  text-starttext-dark">Low Stock</span>
						</div>
						<div className="d-flex align-items-center py-2">
							<div
								className="p-1 rounded-2"
								style={{
									backgroundColor: 'rgba(104, 194, 48, 0.10)',
								}}
							>
								<img
									src={stockIcon}
									alt="Stock"
									width={20}
									height={20}
								/>
							</div>
							<span className="width-110 fs-5 px-3 text-semibold text-start text-dark">
								In-Hand Stock
							</span>
						</div>
					</div>
					<div>
						<div className="d-flex py-2">
							<progress
								className="progress"
								max={data?.total_stock_in_hand}
								value={data?.expiring_soon_products_count}
								style={{ '--bar-color': 'red' }}
							/>
							<span className="fs-5 px-3 text-semibold text-start text-dark">
								{data?.expiring_soon_products_count}
							</span>
						</div>
						<div className="d-flex py-4">
							<progress
								className="progress"
								max={data?.total_stock_in_hand}
								value={data?.low_stock_products_count}
								style={{ '--bar-color': '#f5c542' }}
							/>
							<span className="fs-5 px-3 text-semibold text-start text-dark">
								{data?.low_stock_products_count}
							</span>
						</div>
						<div className="d-flex py-2">
							<progress
								className="progress"
								max={data?.total_stock_in_hand}
								value={data?.total_stock_in_hand}
								style={{ '--bar-color': '#52c41a' }}
							/>
							<span className="fs-5 px-3 text-semibold text-start text-dark">
								{data?.total_stock_in_hand}
							</span>
						</div>
					</div>
				</div>
			)}
		</div>
	);
};
export default InventorySummary;
